import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './IconButton.module.css';
/** Bouton icône seule (16/18 px, lucide-react), toujours annoncé par `aria-label`. */
export const IconButton = forwardRef(function IconButton({ icon, size = 'md', variant = 'ghost', className, ...rest }, ref) {
    const classes = [
        styles.button,
        size === 'sm' ? styles.sm : '',
        variant === 'outline' ? styles.outline : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("button", { ref: ref, type: "button", className: classes, ...rest, children: icon }));
});
//# sourceMappingURL=IconButton.js.map